import React from "react";
import MyDeals from "../Components/Ambassador/Deals/MyDeals";

const AmbassadorMyDealsPage: React.FC = () => <MyDeals />;

export default AmbassadorMyDealsPage;
